import { takeEvery } from 'redux-saga/effects';

// internal
import * as ActionType from '@app/store/typings/actions/permission.d';
import { fetchBrandPermission, fetchProjectPermission } from './fetch';

export function* permissionSaga() {
  yield takeEvery(ActionType.KEY_PERMISSION_BRAND_FETCH, fetchBrandPermission);
  yield takeEvery(ActionType.KEY_PERMISSION_PROJECT_FETCH, fetchProjectPermission);
}
